import React from 'react'
import { ReactComponent as ExpiredIllustration } from 'assets/illustrations/ExpiredIllustration.svg'
import { Email } from 'components/forms/Email'
import { Typography } from 'transfix-ui/core'

export const ExpiredPage = () => {
  const expiredHeader = 'This link has expired'
  const email = 'detention@transfix.io'

  const ExpiredMessage = () => (
    <span>
      To receive a new link, please contact our team at{' '}
      <Email email={email} title={email} subject='' />
    </span>
  )

  return (
    <div className='container mt8'>
      <div className='col-xs-12 flex justify-center items-center'>
        <div className='col-xs-6'>
          <div className='col-xs-12 flex justify-center'>
            <ExpiredIllustration />
          </div>
          <div className='col-xs-12 flex justify-center'>
            <Typography variant='h2'>{expiredHeader}</Typography>
          </div>
          <div className='col-xs-12 flex justify-center text-wrap'>
            <ExpiredMessage />
          </div>
        </div>
      </div>
    </div>
  )
}
